import { useCustomer } from "./customer";

export function CustomerPicker() {
  const { self, personas, selected, select } = useCustomer();

  return (
    <label className="customer-picker">
      <span className="customer-picker-label">Shopping as</span>
      <select value={selected.customerId} onChange={(e) => select(e.target.value)}>
        <optgroup label="You">
          <option value={self.customerId}>{self.name}</option>
        </optgroup>
        {personas.length > 0 && (
          <optgroup label="Seeded personas (testing)">
            {personas.map((c) => (
              <option key={c.customerId} value={c.customerId}>
                {c.name} · {c.tier}
              </option>
            ))}
          </optgroup>
        )}
      </select>
    </label>
  );
}
